import React from "react";
import Box from "@mui/material/Box";
import {
  gridPageSelector,
  useGridApiContext,
  useGridSelector,
} from "@mui/x-data-grid";
import { TablePagination } from "@mui/material";

const CustomPagination = () => {
  const apiRef = useGridApiContext();
  const page = useGridSelector(apiRef, gridPageSelector);

  const [rowsPerPage, setRowsPerPage] = React.useState(apiRef.current.state.pagination.paginationModel.pageSize);
  const rowCount = apiRef.current.state.pagination.rowCount;

  return (
    <Box>
      <TablePagination
        component="div"
        count={rowCount}
        page={page}
        onPageChange={(event, newPage) => apiRef.current.setPage(newPage)}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={(event) => {
          const newPageSize = parseInt(event.target.value, 10);
          apiRef.current.setPageSize(newPageSize);
          setRowsPerPage(newPageSize)
        }}
        rowsPerPageOptions={[10, 20, 50]}
        labelRowsPerPage="Rows per page:"
        labelDisplayedRows={({ from, to, count }) =>
          `${from}–${to} of ${count !== -1 ? count : `more than ${to}`}`
        }
        sx={{
          "& .MuiTablePagination-selectLabel": {
            fontSize: "0.875rem",
          },
          "& .MuiTablePagination-displayedRows": {
            fontSize: "0.875rem",
          },
        }}
      />
    </Box>
  );
};
export default CustomPagination;
